module.exports = __webpack_public_path__ + "img/slide2.39f7aacd.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":636,"height":357,"variants":[{"file":"img/slide2-480w.83c4fb0e78de.webp","width":480},{"file":"img/slide2-636w.ffd9ff776d69.webp","width":636}]};
}